<template>
    <div class="eda-new">

        <h1 class="eda-new__heading">
            {{ $t('newUser.heading') }}
        </h1>

        <div class="eda-new__username">
            <v-input
                    name="email"

                    v-model="email"
                    :darkTheme="true"
                    :label="$t('newUser.email')"/>

        </div>

        <div class="eda-new__password">
            <v-input
                    name="password"
                    type="password"
                    v-model="password"
                    :darkTheme="true"
                    :label="$t('newUser.password')"/>
        </div>

        <div class="eda-new__error" :class="{'eda-new__error--visible': error}">
            {{ errorMessage }}
        </div>

        <div class="eda-new__submit" :class="{'eda-new__submit--error': error}">
            <eda-button
                    @click="createUser()"
                    class="eda-new__button"
                    :label="$t('newUser.submit')"
            >
            </eda-button>
        </div>

        <div class="eda-new__login">
            {{ $t('newUser.existingUser') }}
            <span class="eda-new__login-link">

            <eda-link to="/">
            {{ $t('newUser.login') }}
            </eda-link>
            </span>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';
  import EdaButton from "../components/vButton"
  import EdaLink from "../components/vLink"
  import apiMixin from "../mixins/apiMixin";
  import vInput from "../components/vInput"
  import { mapActions } from 'vuex';

  export default {
    name: "eda-new",
    components: {
      EdaButton,
      vInput,
      EdaLink,
    },
    mixins: [
      apiMixin.apiMixin
    ],
    data: function () {
      return {
        error: false,
        errorMessage: "",
        email: "",
        password: "",
      }
    }, mounted() {


    },
    methods: {
      ...mapActions(["setUser"]),


      createUser() {
        var that = this;
        that.error = false;
        that.loading = true;
        let hash = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);

        axios.post(process.env.VUE_APP_API_URL  + "/users", {
          "email": that.email,
          "password": that.password,
          "groups": ["retailer"],
          "group": 65944,
          'hash': hash,
          "appUrl": window.location.hostname,
        }, that.apiHeaders).then(function (response) {
          that.setUser(response.data);
          // that.setUser(response.data);
          that.$router.push({ path: '/user/confirm/' + hash });

          // that.$router.push({path: '/cars'});
        }).catch(function (error) {
          that.error = true;
          that.errorMessage = error.response.data.error.message;
        }).finally(function () {
          that.loading = false;
        });
      }
    }
  }

</script>

<style>

    .eda-new__heading {
        font-weight: 600;
    }

    .eda-new {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 1.1em;
        padding-top: 4vw;
        color: white;
    }

    .eda-new__password,
    .eda-new__username,
    .eda-new__submit {
        padding: 0 0.5em;
        max-width: 25em;
        width: 100%;
    }

    .eda-new__submit {
        padding-top: 2em;
        display: flex;
        justify-content: center;
        padding-bottom: 1em;
    }

    .eda-new__submit--error {
        animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        perspective: 1000px;
    }

    .eda-new__form-element {
        padding: 1em 2em;
        width: 100%;
        border-radius: 3em;
        border: none;
        outline: none;
        font-weight: 600;
    }

    .eda-new__input {
        color: white;
        background-color: #0E1A10;

    }

    .eda-new__button {
        text-align: center;
        color: white;
        font-size: 1em;
        background-color: #00B27C;
    }

    .eda-new__recover {
        width: 100%;
        max-width: 25em;
        padding: 0.5em 2em 2em 2em;
        text-align: left;
    }

    .eda-new__forgot {
        font-size: 0.8em;
    }

    .eda-new__login {
        padding-top: 1.2em;
        font-size: 0.8em;
    }

    .eda-new__login-link {
        padding-left: 0.75em;
    }

    .eda-new__link {
        color: #00B27C;
        font-weight: 300;
    }

    @keyframes shake {
        10%, 90% {
            transform: translate3d(-1px, 0, 0);
        }

        20%, 80% {
            transform: translate3d(2px, 0, 0);
        }

        30%, 50%, 70% {
            transform: translate3d(-4px, 0, 0);
        }

        40%, 60% {
            transform: translate3d(4px, 0, 0);
        }
    }

</style>